import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'reactstrap/lib/Form';
import { FormConfirmSms2fa as FormConfirmSms2faCore, FormattedTag } from 'core/components';
import { withCoreComponent, withModalActions, withRecaptcha } from 'core/hocs';
import { getEnv } from 'core/helpers';
import { FORM_ACTIONS, LOCAL } from 'core/constants';
import { ButtonWithLoader } from 'components/button-with-loader/button-with-loader';

import { FormElement } from 'src/components/form-element/form-element';
import { CustomCountdown } from 'components/custom-countdown/custom-countdown';
import { MODAL_IDS } from '../../../constants';
import './form-confirm-sms-2fa.scss';

class FormConfirmSms2faUI extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onSignInInterrupted: PropTypes.func.isRequired,
    onSignInRepeat: PropTypes.func.isRequired,
    onProcessWithdrawalInterrupted: PropTypes.func.isRequired,
    onProcessWithdrawalRepeat: PropTypes.func.isRequired,
    action: PropTypes.string,
    clearResendTime: PropTypes.func.isRequired,
    triggerSendingSms: PropTypes.func.isRequired,
    mobile: PropTypes.string,
    fields: PropTypes.shape().isRequired,
    resendTime: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
    isInProgress: PropTypes.bool.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    isFormFilled: PropTypes.bool.isRequired,
    isMobileNumberError: PropTypes.bool,
    closeModal: PropTypes.func.isRequired,
    executeRecaptcha: PropTypes.func.isRequired,
  };

  static defaultProps = {
    mobile: null,
    action: null,
    resendTime: null,
    isMobileNumberError: false,
  };

  countDownRefApi;

  componentDidMount() {
    const { resendTime } = this.props;

    if (resendTime) {
      this.startTimer();
    }
  }

  componentDidUpdate({ resendTime: prevResendTime, isSuccess: isPrevSuccess }) {
    const {
      resendTime,
      isSuccess,
    } = this.props;

    if (!prevResendTime && resendTime) {
      this.startTimer();
    }

    if (isSuccess && !isPrevSuccess) {
      this.closeModal();
    }
  }

  startTimer = () => {
    this.countDownRefApi.start();
  }

  onCountdownComplete = () => {
    const { clearResendTime } = this.props;

    clearResendTime();
  }

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal(MODAL_IDS.CONFIRM_SMS_2FA);
  };

  setRef = (ref) => {
    if (ref) {
      this.countDownRefApi = ref.getApi();
    }
  }

  onResendClick = (e) => {
    const {
      triggerSendingSms,
      action,
      onSignInRepeat,
      onProcessWithdrawalRepeat,
      executeRecaptcha
    } = this.props;

    if (action === FORM_ACTIONS.SIGN_IN) {
      onSignInRepeat(e, executeRecaptcha);

      return;
    }

    if (action === FORM_ACTIONS.PROCESS_WITHDRAWAL) {
      onProcessWithdrawalRepeat(e);

      return;
    }

    triggerSendingSms();
  };

  submit = (e) => {
    const {
      action,
      onSubmit,
      onSignInInterrupted,
      onProcessWithdrawalInterrupted,
      executeRecaptcha
    } = this.props;

    if (action === FORM_ACTIONS.SIGN_IN) {
      const isLocal = getEnv('PROJECT_ENV') === LOCAL;
      onSignInInterrupted(e, executeRecaptcha, isLocal);

      return;
    }

    if (action === FORM_ACTIONS.PROCESS_WITHDRAWAL) {
      onProcessWithdrawalInterrupted(e);

      return;
    }

    onSubmit(e);
  }

  render() {
    const {
      fields,
      isInProgress,
      mobile,
      isFormFilled,
      resendTime,
      isMobileNumberError,
    } = this.props;

    return (
      <Form onSubmit={this.submit}>
        <div className="text-center">
          <FormattedTag className="h2 text-center" id="form.confirm-phone.title" />

          <FormattedTag
            className="mb-3_75 mt-0_5 px-3 d-block"
            id="form.confirm-phone.description"
            values={{ mobile }}
            isHtml
          />
        </div>

        <div className="input-confirm-code position-relative">
          <FormElement
            classNames="mb-1"
            coreProps={{ item: fields.confirmationCode }}
            size="lg"
            isDisabled={isInProgress || isMobileNumberError}
          />
        </div>

        <FormattedTag
          tag={ButtonWithLoader}
          isLoading={isInProgress}
          color="primary"
          className="mt-2 w-100"
          type="submit"
          disabled={!isFormFilled || isMobileNumberError}
          id="verify"
        />

        <CustomCountdown
          date={resendTime}
          onComplete={this.onCountdownComplete}
          innerRef={this.setRef}
          autoStart={false}
        >
          {({ formatted: { minutes, seconds }, completed }) => (
            <>
              {completed ? (
                <FormattedTag
                  tag={ButtonWithLoader}
                  isLoading={isInProgress}
                  color="gray-10-50"
                  className="mt-1_5 w-100"
                  outline
                  onClick={this.onResendClick}
                  disabled={isInProgress || isMobileNumberError}
                  id="resend"
                />
              ) : (
                <div
                  className="w-100 text-center mt-3 d-flex justify-content-between align-items-center h4 font-weight-semi-bold"
                >
                  <div className="resend-line" />
                  {minutes}:{seconds}
                  <div className="resend-line" />
                </div>
              )}
            </>
          )}
        </CustomCountdown>
      </Form>
    );
  }
}

export const FormConfirmSms2fa = withCoreComponent(
  FormConfirmSms2faCore,
  withModalActions(
    withRecaptcha(
      FormConfirmSms2faUI
    )
  )
);
